//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
import PersonalCard from '~/components/Card/PersonalCard';
import { nToW, wToN } from '~/utils/form';
import { jobTypes, workTimeType } from '~/utils/jobs';

export default {
  name: 'ContactInfo',
  components: { PersonalCard },
  props: {
    updatePageData: { type: Function, default: () => {} },
  },
  data() {
    return {
      jobTypes,
      workTimeType,
      isSameAddress: false,
      infoData: {},
      expectedMonthSalary: null,
      expectedAnnualSalary: null,
      rules: {},
      resumeFiles: [],
    };
  },
  watch: {
    resumeData: {
      handler(value) {
        this.infoData = JSON.parse(JSON.stringify(value));
        this.expectedMonthSalary = nToW(this.infoData.expectedMonthSalary);
        this.expectedAnnualSalary = nToW(this.infoData.expectedAnnualSalary);
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters('personal', ['resumeData']),
    ...mapGetters('common', ['areaLocalTree', 'areaWorldTree', 'jobCatTree']),
  },
  methods: {
    ...mapActions('personal', ['setResumeData', 'setIsEdit']),
    handleInfo() {
      this.setResumeData(this.infoData);
      this.setIsEdit(true);
    },
    onAcceptableAbroadChange() {
      this.infoData.acceptableCountry = [];
      this.handleInfo();
    },
    onActWorldChange(selected) {
      this.infoData.acceptableCountry = selected;
      this.handleInfo();
    },
    onActTaiwanChange(selected) {
      this.infoData.acceptableInTaiwan = selected;
      this.handleInfo();
    },
    onSalaryChange() {
      this.infoData.expectedMonthSalary = wToN(this.expectedMonthSalary);
      this.infoData.expectedAnnualSalary = wToN(this.expectedAnnualSalary);
      this.handleInfo();
    },
    onJobCatIdsChange(selected) {
      this.infoData.jobCatIds = selected;
      this.handleInfo();
    },
    onSave() {
      this.$api('userUpdateUserResume', this.resumeData)
        .then(data => {
          this.setIsEdit(false);
          this.$message.success('編輯成功!');
          this.updatePageData();
        })
        .catch(error => {
          this.$message.warning(`編輯失敗! ${error.message}`);
        });
    },
  },
};
